import {request, serviceUrl} from "@/utils/request";

//地理位置列表
export function list() {
    return request({
        url: serviceUrl.extensionService + '/ext/geography/list',
    })
}

//地理位置列表
export function tree() {
    return request({
        url: serviceUrl.extensionService + '/ext/geography/tree',
    })
}